import Signup from "./SignupContainer";

export default Signup;
